import React, { useState } from "react";
import { Table, Modal, Button } from "react-bootstrap";
import PaginationComponent from "../PaginationComponent";

const BranchChangeDiffModal = ({ show, onHide, onConfirm, diffData = [], submitting }) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(100);

  const startIndex = (currentPage - 1) * itemsPerPage;
  const paginatedData = diffData.slice(startIndex, startIndex + itemsPerPage);

  return (
    <Modal show={show} onHide={onHide} size="lg" centered>
      <Modal.Header closeButton>
        <Modal.Title>Podgląd zmian ({diffData.length} kodów)</Modal.Title>
      </Modal.Header>
      <Modal.Body style={{ maxHeight: "60vh", overflowY: "auto" }}>
        <Table responsive striped bordered hover size="sm">
          <thead>
            <tr>
              <th>Kod pocztowy</th>
              <th>Stary EX</th>
              <th>Stary DR</th>
              <th>Nowy EX</th>
              <th>Nowy DR</th>
            </tr>
          </thead>
          <tbody>
            {paginatedData.length > 0 ? (
              paginatedData.map((item, index) => (
                <tr key={index}>
                  <td>{item.postcode}</td>
                  <td>{item.oldEx || "—"}</td>
                  <td>{item.oldDr || "—"}</td>
                  <td>{item.newEx || "—"}</td>
                  <td>{item.newDr || "—"}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="5" className="text-center">
                  Brak danych
                </td>
              </tr>
            )}
          </tbody>
        </Table>
        {diffData.length > itemsPerPage && (
          <PaginationComponent
            itemsPerPage={itemsPerPage}
            dataCount={paginatedData.length}
            onPageChange={(page) => setCurrentPage(page)}
            onItemsPerPageChange={(pageSize) => {
              setItemsPerPage(pageSize);
              setCurrentPage(1);
            }}
            itemsPerPageOptions={[100, 250, 500, 1000, 5000]}
          />
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Anuluj
        </Button>
        <Button variant="primary" onClick={onConfirm} disabled={submitting}>
          {submitting ? "Zapisywanie..." : "Potwierdź"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default BranchChangeDiffModal;
